<template>
  <div class="affixDoc">
    <el-form :model="item" status-icon ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm">
      <el-form-item  prop="pass">
        <!-- label slot -->
        <span slot="label" :title="name" :alt="name" class="label-wrap">
            {{ name ? ( name + '：') : '附件信息：' }}
        </span>
          <!-- <p>{{item.name}}</p> -->
          <template v-if="item.attFiles">
            <template v-if="item.attFiles.length > 0">
              <div v-for="f in item.attFiles" :key="f.filePath" style="position: relative;">
                <p>{{f.name}}
                  <span v-show="item.attributes && item.attributes.showSignBtn">
                    <el-tag size="small" v-if="f.isSeal" type="success">已签章</el-tag>
                    <el-tag size="small" v-else type="danger">未签章</el-tag>
                  </span>
                </p>
                <label class="upload">
                  <em  v-show="f.filePath" class="el-icon-view" @click="fileView(f)"></em>
                  <em  v-show="f.filePath" class="el-icon-download" style="margin-left:10px" @click="fileDownload(f)"></em>
                  <span v-show="item.attributes && item.attributes.showSignBtn" class="sign-btn" style="margin-left:10px; cursor: pointer;" @click="handlePdf(f)">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  width="14" height="14">
                      <path d="M3.21094 19.9551H21.2116V21.9551H3.21094V19.9551ZM19.8814 14.6217H15.5141C15.1203 14.1569 14.8406 13.63 14.7948 13.0392C14.6072 10.6228 17.2115 9.46574 17.2115 6.5021C17.2115 3.98499 15.2948 1.95508 12.2113 1.95508C9.12786 1.95508 7.21113 3.98501 7.21113 6.5021C7.21113 9.46574 9.81538 10.6228 9.62787 13.0392C9.58199 13.63 9.30233 14.1569 8.90853 14.6217H4.54112C3.80653 14.6217 3.211 15.2173 3.211 15.9518V18.6218H21.2116V15.9518C21.2116 15.2173 20.6161 14.6217 19.8814 14.6217Z"></path>
                    </svg> -->
                    签章
                  </span>
                </label>
              </div>
            </template>
            <template v-else>
              <p></p>
            </template>
          </template>
          <template v-else>
          <p>{{item.name}}</p>
          <label class="upload">
            <em  v-show="this.item.filePath" class="el-icon-view" @click="fileView(item)"></em>
            <em  v-show="this.item.filePath" class="el-icon-download" style="margin-left:10px" @click="fileDownload(item)"></em>
            <span v-if="filingCBtn" style="margin-left:10px" @click="handlePdf(item)">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  width="14" height="14">
                <path d="M3.21094 19.9551H21.2116V21.9551H3.21094V19.9551ZM19.8814 14.6217H15.5141C15.1203 14.1569 14.8406 13.63 14.7948 13.0392C14.6072 10.6228 17.2115 9.46574 17.2115 6.5021C17.2115 3.98499 15.2948 1.95508 12.2113 1.95508C9.12786 1.95508 7.21113 3.98501 7.21113 6.5021C7.21113 9.46574 9.81538 10.6228 9.62787 13.0392C9.58199 13.63 9.30233 14.1569 8.90853 14.6217H4.54112C3.80653 14.6217 3.211 15.2173 3.211 15.9518V18.6218H21.2116V15.9518C21.2116 15.2173 20.6161 14.6217 19.8814 14.6217Z"></path>
              </svg>
            </span>
          </label>
          </template>
      </el-form-item>
    </el-form>
      <el-dialog :visible.sync="imgDialogVisible" :modal="showModal" width="100%" height="100%" @closed="dialogClose">
          <img :src="filePath" alt="" @contextmenu.prevent=""  class="viewImg">
      </el-dialog>
      <el-dialog :visible.sync="pdfDialogVisible" width="100%" height="100%" @closed="dialogClose">
          <iframe  :src="pdfViewer + this.filePath " frameborder="0" width="100%" height="500" @contextmenu.prevent=""></iframe>
      </el-dialog>
      <el-dialog title="PDF签章页面" :visible.sync="dialogVisible">
        <el-radio-group v-model="signType">
          <el-radio label="1">介质CA</el-radio>
          <el-radio label="2">移动CA</el-radio>
        </el-radio-group>
        <template slot="footer">
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleBtnSelectSignFn">确 定</el-button>
        </template>
      </el-dialog>
      <!-- 移动CA dialog -->
      <el-dialog title="移动CA签章页面" :visible.sync="caVisible" width="1180px">
        <div class="ca_container">
          <template v-if="!isIe">
            <el-button type="primary" @click="showAipWnd(1)">显示窗口最大</el-button>
            <el-button type="primary"  @click="showAipWnd(9)">显示窗口居中</el-button>
            <el-button type="primary" @click="exAddSealFn">手动盖章</el-button>
            <el-button type="primary" @click="addMultSeal">手动多页盖章</el-button>
            <el-button type="primary" @click="getnotenums">获取签章个数</el-button>
            <el-button type="primary" @click="saveFileHandle">保存服务器</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="getIeBxtSealNum(true)">获取签章个数</el-button>
            <el-button type="primary" @click="saveToServer()">保存服务器</el-button>
            <div style="width:1140px;height:500px;margin:10px auto;overflow:scroll;">
                  <object id="HWPostil1" height='100%' width='100%' style='left: 0px; top: 0px;'
                      classid='clsid:FF1FE7A0-0578-4FEE-A34E-FB21B277D563'></object>
            </div>
          </template>
        </div>
      </el-dialog>

      <!-- pm_pdf_container -->
      <el-dialog title="PDF签章页面" :visible.sync="pmPdfVisible" @close="pmPdfVisible = false">
        <div id="pm_pdf_container" style="height: 600px;"></div>
        <template #footer>
          <el-button @click="pmPdfVisible = false">取 消</el-button>
          <el-button type="primary" @click="signWindowSaveClick">确 定</el-button>
        </template>
      </el-dialog>
<!--
      <el-dialog title="PDF签章页面" :visible.sync="iframeVisible">
        <iframe :src="iframUrl" frameborder="0" width="100%" height="500"></iframe>
      </el-dialog> -->
  </div>
</template>

<script>
    import $ from "jquery";
    import {isIEBrowser} from '@/utils/index';
    const PmUtils = require('pm-utils/lib/pm-utils.ie');


    export default {
    name: "index",
    data() {
      return {
          isIe: false,
          url:'',
          pdfViewer:'/pdf/web/viewer.html?file=',
          imgDialogVisible:false,
          pdfDialogVisible:false,
          dialogImageUrl:'',
          filePath:'',
          dialogVisible: false,
          pmPdfVisible: false,
          caVisible: false,
          signType: '1',
          // iframeVisible: false,
          iframUrl: '',
          signWindowOptions: {
              url: '', // 待签章的pdf路径
              fileName: '', // 回写的文件名称
              fileIndex: null, // 回写的附件下标
              signSuccess: false, // 签章是否成功
              mustSign: false, // 是否必须签章
          },
          activeItem: {},
      }
    },
    watch: {
      caVisible: {
        handler(newVal, oldVal) {
          if (newVal) {
            if (this.isIe) {
              setTimeout(() => {
                const fileUploadPath = window.location.origin + this.signWindowOptions.url
                loadFileAndInitLogin(fileUploadPath);
              }, 300);
            }
          }
        },
        immediate: true
      }
    },
    props: {
      index: {
        type: Number,
        required: true
      },
      labelWidth: {
          type: String,
          default:"180px"
      },
      item: {
        type: Object,
        required: true
      },
      showModal: {
          type: Boolean,
          default:true,
      },
      name: {
        type: String,
        required: true
      },
      filingCBtn: {
        type: Boolean,
        default: false
      }
    },
    methods:{
      getIeBxtSealNum() {
        window.getSealNum(true)
      },
      saveToServer() {
        const fileUploadServe = `${window.location.origin}${this.$http.adornUrl('/api/bxt/uploadFile.do')}`
        const _self = this
        window.uploadPdfIE(fileUploadServe, function(data) {
          _self.$emit('updateItem',
                _self.signWindowOptions.fileIndex,
                data.filepath,
              )
            const oldFilePath = _self.signWindowOptions.url
            _self.updateUrl(data.filepath, oldFilePath)
            _self.caVisible = false
        })
      },
      IsShow(item){
        var mark = ''
          try {
            mark=item.remark?JSON.parse(item.remark):'';
          } catch(e){
          console.log(e)
          return false
          }
          if(mark && mark.signatureFlag && mark.signatureFlag==true){
          return true
          }
          return false

      },
      handlePdf(item){
        this.activeItem = item;
        this.dialogVisible = true
        this.signWindowOptions.url = item.filePath
        this.signWindowOptions.fileName = item.name
        this.signWindowOptions.fileIndex = this.index
      },
      updateUrl(newFile, oldFile){
        // this.$http.get(`/attachment/serverOverWriteFile?newFile=${newFile}&oldFile=${oldFile}`,).then(res => {
        //   if(res.data.code === 200){
        //     this.url = res.data.data
        //     this.dialogVisible = false
        //     this.pmPdfVisible = false
        //   }
        // })

        // this.$message.success('即将文件updateUrl接口')

        const params = {
          bizId: this.activeItem.bizId, //业务id
          name: this.activeItem.name, //业务id
          fileType: this.activeItem.fileType, //文件名加后缀的全称
          newFilePath: newFile, //新文件路径
          oldFilePath: oldFile, //老文件路径
          remark: this.activeItem.remark, //remark
          attrId: this.activeItem.id //文件的id
        };

        this.$http.post(`/attachmentAssociation/saveAndReplace`, params).then(res => {
          if(res.data.code == '1'){
            // this.url = res.data.data
            this.$emit('updateFileList');
            this.dialogVisible = false
            this.pmPdfVisible = false
            this.activeItem = {}
          }else {
            this.activeItem = {}
            this.$message.error('操作失败');
          }
        })

      },
      signWindowSaveClick() {
        // if(!this.signWindowOptions.signSuccess && this.signWindowOptions.mustSign){
        //   this.$message.error('必签文件未签章不可保存')
        //   return
        // }
        // this.signWindowOptions.sealNum = (this.signPDF && this.signPDF.getSealNum && this.signPDF.getSealNum({isOne: true}) || null)
        const signfileName = this.signWindowOptions.fileName
        const oldFilePath = this.signWindowOptions.url

        const _self = this
        let  params = {
            table: 'signed_file',
            fileName: signfileName,
          }

        const num = _self.signPDF && _self.signPDF.getSealNum({isOne: true}) || 0;
        if(num > 0 ) {
          const fileUploadServe = `${window.location.origin}${this.$http.adornUrl('/api/jg/uploadFile.do')}`;
          // alert('fileUploadServe', fileUploadServe, oldFilePath);
          _self.signPDF.pmUploadHttpPost({
            url: fileUploadServe,
            pam: params,
            error: (res) => {
              console.log(res, 'error');
            },
            success: (res) => {
              const resData = JSON.parse(res.data) || {}
              if(resData.code == '1'){
                _self.updateUrl(resData.filepath, oldFilePath)
                if(resData.filepath){
                  _self.dialogVisible = false
                  _self.$emit('updateItem',
                    _self.signWindowOptions.fileIndex,
                    resData.filepath,
                  )
                  _self.filePath = resData.filepath;
                  _self.signWindowOptions.filePath = resData.filepath || '';
                  _self.signWindowOptions.signSuccess = true;
                  _self.pmPdfVisible = false;
                }else{
                  _self.signWindowOptions.signSuccess = false;
                }

              }
            }
          })
        }else {
          this.$message.info('请先签章')
        }

      },
      handleBtnSelectSignFn() {
            const url = this.signWindowOptions.url
            const fileName = this.signWindowOptions.fileName
            const val = this.signType
            if (val === '1') {
                this.openJinGePDFSignWindow({
                    url:url, // 待签章的pdf路径
                    fileName:fileName || url, // 回写的文件名称
                    fileIndex: this.index, // 回写的附件下标
                })
            } else {
                this.caVisible = true
            }
        },
        openJinGePDFSignWindow(options) {
            // 判断是不是ie
            if (!isIEBrowser()) {
                this.$message.error('请使用IE浏览器进行签章操作');
                return
            }
            this.signWindowOptions = options
            var type = this.signWindowOptions.url.substr(this.signWindowOptions.url.lastIndexOf(".") + 1);
            var pdfFlag = this.isAssetTypeAnPDF(type);
            if (!pdfFlag) {
                this.$message.error('非PDF文件，不可进行签章操作')
                return
            }

            this.pmPdfVisible = true;


            setTimeout(() => {
              try {
                this.signPDF = new PmUtils.pdf.Jingge();
                this.signPDF.openUrlPDF({url: window.location.origin + this.signWindowOptions.url})
              } catch (e) {
                this.$message.error('请安装金格PDF插件')
                return
              }
            }, 300);

        },
        async showAipWnd(p1) {
          var level=await SetDispidShowWndLevel(2,'','','','');
          var closebtn=await dispidEnableCloseBtn(1,'','','','');
          var showaip=await ShowAipWnd(p1,50,50,'','','','');
        },
        // 手动盖章
        async exAddSealFn() {
          const fileUploadPath = window.location.origin + this.signWindowOptions.url

          const mobileAppKey = process.env.VUE_APP_mobileAppKey
          const mobileAppId = process.env.VUE_APP_mobileAppId

          await CloseDoc(0,'','','','')
          await OpenFile(fileUploadPath)

          const codeurl = process.env.VUE_APP_bxtUrl
          await SetValue("SET_MOBILE_KEYURL", codeurl,"","","","");
          await SetValue("SET_MOBILE_APPKEY", mobileAppKey,"","","","");
          await SetValue("SET_MOBILE_APPID", mobileAppId,"","","","");
          await SetValue("DEL_FORCETYPE_VALUE2","2","","","","");	//去除右键完成盖章操作，完成签名。
          var islogin=await Login("bx", 1, 65535, "bx", "","","","","");	//用户登录
          if (islogin !== 0) {
              console.log(typeof(islogin));
              await ShowMessage("登录失败！返回值为："+parseInt(islogin)+"","提示",0,"","","","");
              return islogin;
          }
        },
        addMultSeal() {
          addMultSeal()
        },
        getnotenums() {
          getnotenums(true)
        },
        saveFileHandle() {
          // const fileUploadServe = `http://192.168.1.109:10280/bxt/uploadFile.do`
          const fileUploadServe = `${window.location.origin}${this.$http.adornUrl('/api/bxt/uploadFile.do')}`

          SaveToS(1,fileUploadServe,'pdf', (data) => {
            console.log(data, 'saveToS')
            this.$emit('updateItem',
                this.signWindowOptions.fileIndex,
                data.filepath,
              )
            const oldFilePath = this.signWindowOptions.url
            this.updateUrl(data.filepath, oldFilePath)
            this.caVisible = false

          })
        },

      fileView(item){

          // 获取文件类型
          let type = item.name.substr(item.name.lastIndexOf(".")+1);
          let imgFlag = this.isAssetTypeAnImage(type);
          // let videoFlag = this.isAssetTypeAnVideo(type);
          // let audioFlag = this.isAssetTypeAnAudio(type);
          let pdfFlag = this.isAssetTypeAnPDF(type);

          if(pdfFlag){
              // this.imgDialogVisible = false;
              // this.pdfDialogVisible = true;
              // this.filePath = item.filePath;
              window.open(this.pdfViewer + item.filePath, '_blank');
              return
          }

          if(imgFlag){

              this.$http({
                  method:'POST',
                  url:`/attachment/getAttachmentByCiteIdAndFileType?bizid=${item.bizId}&fileType=${item.fileType}`,
              }).then(res => {
                  if(res.data.code == '1'){
                      this.filePath = res.data.data.filePath;
                      this.imgDialogVisible = true;
                      this.pdfDialogVisible = false;
                  }
              })


          }else{

              this.fileDownload(item);

          }



      },
        dialogClose() {
            this.dialogImageUrl = "";
            this.imgDialogVisible = false;
        },

        isAssetTypeAnCompressed(ext){
            let arr = ['zip','Z', 'rar','sit','sys','tmp','gz','cab','7z'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnImage(ext){
            let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnVideo(ext) {
            let arr = ['mp4', 'rmvb', 'flv', 'mpeg', 'avi', 'mov', 'wmv', 'ram']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnAudio(ext) {
            let arr = ['mp3', 'wav', 'wma', 'ogg', 'ape', 'acc']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },
        isAssetTypeAnPDF(ext) {
            let arr = ['pdf', 'PDF']
            return arr.indexOf(ext.toLowerCase()) !== -1;
        },

      fileDownload(item){
        if(item.filePath){
          this.$http({
              method:'get',
              url:`/attachment/downloadFile?businessId=${item.bizId}&fileType=${item.fileType}&id=${item.id}`,
              // responseType:'blob'
          }).then(res => {
              if(res.data.code==='1'){
                  var a = document.createElement('a');
                  a.download = this.item.name;
                  a.target="_Blank";
                  a.href = res.data.data;
                  $("body").append(a);
                  a.click();
                  $(a).remove();

              }else{

                  this.$message({
                      type:'error',
                      message:res.data.msg
                  })

              }

          })
        }
      },
    },
    mounted() {
      this.isIe = isIEBrowser()
      this.pdfViewer = this.$http.adornUrl(this.pdfViewer);
      // if (this.isIe) {
      //   setTimeout(() => {
      //     const fileUploadPath = process.env.VUE_APP_uploadUrl + this.signWindowOptions.url
      //     loadFileAndInitLogin(fileUploadPath);
      //   }, 1000);
      // }
    }
  }
</script>

<style lang="less" scoped>
  em{
    cursor: pointer;
  }
  /deep/ .el-form-item__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
